import { FC, useEffect } from 'react';
import { headerStore } from '@modules/header/adapter/outbound/stores/header.store';
import useLockedBody from '@shared/utils/hooks/useLockedBody.utils';
import HeaderLayout from './HeaderLayout';
const HeaderLayoutLogic: FC = () => {
  const [_locked, setLocked] = useLockedBody(false, 'root');
  const {
    isGinARaiDeeMenuOpen,
    setIsSearchModalOpen
  } = headerStore(state => state);
  useEffect(() => {
    setLocked(isGinARaiDeeMenuOpen);
  }, [isGinARaiDeeMenuOpen]);
  return <HeaderLayout onOpenSearchModal={() => setIsSearchModalOpen(true)} />;
};
export default HeaderLayoutLogic;